import {useStoreSelector} from "../redux/useStoreSelector";
import {useCallback, useMemo, useState} from "react";
import {dispatcher} from "../../store";

type Task<T> = Promise<T> | (() => Promise<T>);

export function useFetching(isGlobal: boolean = true) {
  const global = useStoreSelector((s) => s.system.fetching),
    [local, setLocal] = useState(false);

  const withFetching = useCallback(async <T>(p: Task<T>): Promise<T> => {
    if (isGlobal) {
      dispatcher.system.inc();
    } else {
      setLocal(true);
    }
    try {
      return await (typeof p === "function" ? p() : p);
    } catch (e) {
      console.error('ERROR', e)
      throw e;
    } finally {
      if (isGlobal) {
        dispatcher.system.dec();
      } else {
        setLocal(false);
      }
    }
  }, [isGlobal]);

  const fetching = useMemo(() => (isGlobal ? global : local), [
    global,
    isGlobal,
    local,
  ]);

  return { fetching, withFetching, local, global };
}
